import React from 'react';
interface TextScoreSelectorProps {
  attributeId: string;
  attributeName: string;
  currentScore: number;
  onChange: (attributeId: string, score: number) => void;
  options: {
    score: number;
    description: string;
    disabled?: boolean;
  }[];
}
const TextScoreSelector: React.FC<TextScoreSelectorProps> = ({
  attributeId,
  attributeName,
  currentScore,
  onChange,
  options
}) => {
  return <div className="mb-8" data-id="element-43">
      <div className="bg-white rounded-lg border border-gray-200 p-6 transition-shadow hover:shadow-md" data-id="element-44">
        <h3 className="text-lg font-semibold mb-4 text-gray-800" data-id="element-45">
          {attributeName}
        </h3>
        <div className="space-y-3" data-id="element-46">
          {options.map(option => <div key={option.score} className={`flex items-start p-3 rounded-md transition-colors ${currentScore === option.score ? 'bg-orange-50 border border-orange-300' : 'hover:bg-gray-50'}`} data-id="element-47">
              <input type="radio" id={`${attributeId}-${option.score}`} name={attributeId} value={option.score} checked={currentScore === option.score} onChange={() => !option.disabled && onChange(attributeId, option.score)} disabled={option.disabled} className="mt-1 h-4 w-4 text-orange-500 border-gray-300 focus:ring-orange-500" data-id="element-48" />
              <label htmlFor={`${attributeId}-${option.score}`} className={`ml-3 cursor-pointer flex-grow ${option.disabled ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-49">
                <span className="font-medium block" data-id="element-50">{option.score} pontos</span>
                <span className="text-sm block" data-id="element-51">{option.description}</span>
              </label>
            </div>)}
        </div>
      </div>
    </div>;
};
export default TextScoreSelector;